import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NavigateComponent } from './navigate-page/NavigateComponent'

const appRoutes: Routes = [
	{	path: '', 
		redirectTo: 'login', 
		pathMatch: 'full' 
	},
	 {
		 path: 'navigate',
		 component: NavigateComponent
	 }
];

export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/auth/AppRouting.ts